import { render } from "./ManagePage.vue?vue&type=template&id=8525a7b2&scoped=true"
import script from "./ManagePage.vue?vue&type=script&lang=js"
export * from "./ManagePage.vue?vue&type=script&lang=js"

import "./ManagePage.vue?vue&type=style&index=0&id=8525a7b2&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8525a7b2"]])

export default __exports__